<template>
<div>
    <!-- style="cursor: default; left: auto; bottom: auto; right: auto; top: 474px; position: fixed;" -->
    <table id="keyboardInputMaster2" border="0" cellpadding="0" cellspacing="0"  class="keyboardInputMaster">
        <tbody>
            <tr>
                <td colspan="2">
                    <div id="keyboardInputLayout2" class="keyboardInputLayout">
                        <div>
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tbody>
                                    <tr>
                                        <td class="" @click="keyClick(key_list[0][0][shift_state])">{{key_list[0][0][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][1][shift_state])">{{key_list[0][1][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][2][shift_state])">{{key_list[0][2][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][3][shift_state])">{{key_list[0][3][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][4][shift_state])">{{key_list[0][4][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][5][shift_state])">{{key_list[0][5][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][6][shift_state])">{{key_list[0][6][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][7][shift_state])">{{key_list[0][7][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][8][shift_state])">{{key_list[0][8][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[0][9][shift_state])">{{key_list[0][9][shift_state]}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tbody>
                                    <tr>
                                        <td class="" @click="keyClick(key_list[1][0][shift_state])">{{key_list[1][0][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][1][shift_state])">{{key_list[1][1][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][2][shift_state])">{{key_list[1][2][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][3][shift_state])">{{key_list[1][3][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][4][shift_state])">{{key_list[1][4][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][5][shift_state])">{{key_list[1][5][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][6][shift_state])">{{key_list[1][6][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][7][shift_state])">{{key_list[1][7][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][8][shift_state])">{{key_list[1][8][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[1][9][shift_state])">{{key_list[1][9][shift_state]}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tbody>
                                    <tr>
                                        <td class="" @click="keyClick(key_list[2][0][shift_state])" style="border-left:50px solid #ddd;">{{key_list[2][0][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][1][shift_state])">{{key_list[2][1][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][2][shift_state])">{{key_list[2][2][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][3][shift_state])">{{key_list[2][3][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][4][shift_state])">{{key_list[2][4][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][5][shift_state])">{{key_list[2][5][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][6][shift_state])">{{key_list[2][6][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][7][shift_state])">{{key_list[2][7][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[2][8][shift_state])">{{key_list[2][8][shift_state]}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tbody>
                                    <tr>
                                        <td class="" @click="keyClick(key_list[3][0][shift_state])" style="font-size:30px;">
                                                {{key_list[3][0][shift_state]}}
                                        </td>
                                        <td class="" @click="keyClick(key_list[3][1][shift_state])">
                                            <img src="../../../_include/img/shift2.png" style="width:36px;height:40px;">
                                        </td>
                                        <td class="" @click="keyClick(key_list[3][2][shift_state])">{{key_list[3][2][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[3][3][shift_state])">{{key_list[3][3][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[3][4][shift_state])">{{key_list[3][4][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[3][5][shift_state])">{{key_list[3][5][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[3][6][shift_state])">{{key_list[3][6][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[3][7][shift_state])">{{key_list[3][7][shift_state]}}</td>
                                        <td class="" @click="keyClick(key_list[3][8][shift_state])">{{key_list[3][8][shift_state]}}</td>
                                        <td class=" last" @click="keyClick(key_list[3][9][shift_state])">
                                            <img src="../../../_include/img/delete2.png" style="width: 50px;height: 60px;position: relative;top: 10px;">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div><var></var></div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
const VK_layout = new Object();
VK_layout.type = {KR:'KR', US:'US'};
VK_layout.KR = [ // Korea Standard Keyboard
    [["1", "!"], ["2", "@"], ["3", "#"], ["4", "$"], ["5", "%"], ["6", "^"], ["7", "&"], ["8", "*"], ["9", "("], ["0", ")"]],
    [["ㅂ", "ㅃ"], ["ㅈ", "ㅉ"], ["ㄷ", "ㄸ"], ["ㄱ", "ㄲ"], ["ㅅ", "ㅆ"], ["ㅛ", "ㅛ"], ["ㅕ", "ㅕ"], ["ㅑ", "ㅑ"], ["ㅐ", "ㅒ"], ["ㅔ", "ㅖ"],],
    [["ㅁ", "ㅁ"], ["ㄴ", "ㄴ"], ["ㅇ", "ㅇ"], ["ㄹ", "ㄹ"], ["ㅎ", "ㅎ"], ["ㅗ", "ㅗ"], ["ㅓ", "ㅓ"], ["ㅏ", "ㅏ"], ["ㅣ", "ㅣ"]],
    [["Eng", "Eng"], ["Shift", "Shift"], ["ㅋ", "ㅋ"], ["ㅌ", "ㅌ"], ["ㅊ", "ㅊ"], ["ㅍ", "ㅍ"], ["ㅠ", "ㅠ"], ["ㅜ", "ㅜ"], ["ㅡ", "ㅡ"], ["삭제", "삭제"]]
];

VK_layout.US = [ // US Standard Keyboard
    [["1", "!"], ["2", "@"], ["3", "#"], ["4", "$"], ["5", "%"], ["6", "^"], ["7", "&"], ["8", "*"], ["9", "("], ["0", ")"]],
    [["q", "Q"], ["w", "W"], ["e", "E"], ["r", "R"], ["t", "T"], ["y", "Y"], ["u", "U"], ["i", "I"], ["o", "O"], ["p", "P"]],
    [["a", "A"], ["s", "S"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"]],
    [["한글", "한글"], ["Shift", "Shift"],["z", "Z"], ["x", "X"], ["c", "C"], ["v", "V"], ["b", "B"], ["n", "N"], ["m", "M"], ["Delete", "Delete"]]
];

import * as Hangul from 'hangul-js';

// 사용자 정의 모듈.
export default {
    props: {
        parent_key_str:String,
    },
    // props: ['parent_key_str'],
    data: function () {
        return {
            language: VK_layout.type.US,
            shift_state: 0,
            inputKeyList: Hangul.disassemble(this.parent_key_str),
        }
    },
    computed : {
        // 현재 상태의 키
        key_list: function () {
            return VK_layout[this.language];
        },
        // parent_key_str_disassemble: function () {
        //     return Hangul.disassemble(this.parent_key_str);
        // },
    },
    methods: {
        keyClick(key) {
            // console.log('key~~~~~~~~~~~~~~>',key);
            if( key=='Eng' || key=='한글' ) {
                this.language = this.language==VK_layout.type.KR?VK_layout.type.US:VK_layout.type.KR;
                return;
            }
            if( key=='Shift' ) {
                this.shift_state = this.shift_state==0?1:0;
                return;
            }
            if( key=='Delete' || key=='삭제'  ) this.inputKeyList.splice(this.inputKeyList.length-1, this.inputKeyList.length);
            else this.inputKeyList.push( key );

            const keyStr = Hangul.assemble(this.inputKeyList);
            this.$emit("keyClick",keyStr);
        }
    },
    mounted() {
        // this.inputKeyList = this.parent_key_str_disassemble;
    },
    watch: {
        parent_key_str() {
            this.inputKeyList = Hangul.disassemble(this.parent_key_str);
        }
    },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/components/vk-eng2.vue